import { render, staticRenderFns } from "./baa.html?vue&type=template&id=f39807ae&"
import script from "./baa.js?vue&type=script&lang=js&"
export * from "./baa.js?vue&type=script&lang=js&"
import style0 from "./baa.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports